import React from 'react';
import NinjaTable from 'components/tables/NinjaTable';
import { useJourneyReport } from 'modules/ReportModule/context/useJourneyReport';
import Icon from '@mdi/react';
import Ninja from '@ninja';
import {
  mdiEye,
  mdiCalendarBlankOutline,
  mdiAccountGroup,
  mdiCalendar,
  mdiAlertCircleOutline,
  mdiCheckCircleOutline,
  mdiClockOutline,
  mdiCalculatorVariant,
} from '@mdi/js';
import { Flex, Tooltip, Typography } from 'antd';
import JourneyUrlFormatter from 'modules/ReportModule/components/JourneyUrlFormatter';
import { DateFormatter } from 'components/charts/formatters';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';

const { Text } = Typography;

const TrafficReportingReferrers = () => {
  const { filter } = useJourneyReport();

  const MetricCell = ({ value, icon, color = Ninja.colors.gray, isCurrency = false }) => (
    <Flex align='center' gap={6}>
      <Icon size={0.7} path={icon} color={color} />
      <Text strong style={{ fontSize: 13, color: Ninja.colors.text }}>
        {isCurrency ? getFormattedNumber(value) : getFormattedNumber(value)}
      </Text>
    </Flex>
  );

  const columns = [
    {
      key: 'page',
      name: 'Page URL',
      renderCell: ({ row }) => (
        <div style={{ maxWidth: 280 }}>
          <JourneyUrlFormatter url={row?.referrer?.page} />
        </div>
      ),
      resizable: true,
    },
    {
      key: 'domain',
      name: 'Domain',
      resizable: true,
      renderCell: ({ row }) =>
        row?.website?.id ? (
          <Flex align='center' gap='small'>
            <Tooltip
              title={row?.website?.verified ? 'Verified domain' : 'Unverified domain'}
              placement='top'
            >
              <Icon
                size={0.7}
                path={row?.website?.verified ? mdiCheckCircleOutline : mdiAlertCircleOutline}
                color={row?.website?.verified ? Ninja.colors.success : Ninja.colors.warning}
              />
            </Tooltip>
            {row?.website?.host && <JourneyUrlFormatter url={row?.website?.host} />}
          </Flex>
        ) : (
          <Text type='secondary'>-</Text>
        ),
    },
    {
      key: 'page_views',
      name: 'Views',
      sortable: true,
      renderCell: ({ row }) => (
        <MetricCell value={row?.page_views} icon={mdiEye} color={Ninja.colors.primary} />
      ),
    },
    {
      key: 'total_events',
      name: 'Events',
      sortable: true,
      renderCell: ({ row }) => (
        <MetricCell
          value={row?.total_events}
          icon={mdiCalendarBlankOutline}
          color={Ninja.colors.info}
        />
      ),
    },
    {
      key: 'total_events_value',
      name: 'Event Value',
      sortable: true,
      renderCell: ({ row }) => (
        <MetricCell
          value={row?.total_events_value}
          icon={mdiCalculatorVariant}
          color={Ninja.colors.medium}
          isCurrency
        />
      ),
    },
    {
      key: 'total_sessions',
      name: 'Sessions',
      sortable: true,
      renderCell: ({ row }) => (
        <MetricCell
          value={row?.total_sessions}
          icon={mdiClockOutline}
          color={Ninja.colors.warning}
        />
      ),
    },
    {
      key: 'visitors',
      name: 'Visitors',
      sortable: true,
      renderCell: ({ row }) => (
        <MetricCell value={row?.visitors} icon={mdiAccountGroup} color={Ninja.colors.bgColorDark} />
      ),
    },
    {
      key: 'date',
      name: 'Date',
      sortable: true,
      renderCell: ({ row }) => (
        <Flex align='center' gap={6}>
          <Icon
            size={0.6}
            path={mdiCalendar}
            color={Ninja.colors.textSecondary}
            style={{ opacity: 0.6 }}
          />
          <DateFormatter date={row.date} format='MMM DD, YYYY' className='font-normal' />
        </Flex>
      ),
    },
  ];

  return (
    <NinjaTable
      cardProps={{ disable: true }}
      title='Referrers'
      dataProvider='getReferrers'
      columns={columns}
      queryParams={{
        filters: {
          ...filter,
        },
      }}
    />
  );
};

export default TrafficReportingReferrers;
